// import Spline from '@splinetool/react-spline';

export default function AmbiencePink() {
  const iconPath = process.env.PUBLIC_URL;
  return (
    // <Spline scene="https://prod.spline.design/l9K372MqB6WXy08v/scene.splinecode" />
    <img src={iconPath + "/ambience-pink.png"} alt="" className="ambience" />
  );
}
